@use 'sass:map';
@import '../../themes/capsule.globals';

:host {
  display: none;

  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;

  z-index: map.get($z-indices, 'modal');

  & .card {
    z-index: map.get($z-indices, 'modal');
    opacity: 0;

    position: relative;

    transition: all;
  }
}

:host(.no-overlay) {
  position: relative;
  top: unset;
  left: unset;
  width: 100%;
  height: auto;
}

:host(.open) {
  & .card {
    opacity: 1;
  }
}

:host(.elevated) {
  & .card {
    --card-border-width: 0px;

    &::part(card-container) {
      box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.12);
    }
  }
}
